import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Button } from './ui/button';
import { Menu, X } from 'lucide-react';
import { Logo } from './Logo';
import { shopInfo } from '../mock';

export const Header = () => {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
      setMobileMenuOpen(false);
    }
  };

  return (
    <header className="fixed top-0 left-0 right-0 bg-stone-700/95 backdrop-blur-sm border-b border-stone-600 z-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-20">
          {/* Logo */}
          <div className="flex items-center cursor-pointer" onClick={() => scrollToSection('hero')} data-testid="header-logo">
            <Logo variant="full-light" className="h-14 w-auto" />
            <p className="hidden sm:block ml-3 text-xs text-stone-400 border-l border-stone-500 pl-3">
              Since {shopInfo.ownedSince}
            </p>
          </div>

          {/* Desktop Navigation */}
          <nav className="hidden md:flex items-center space-x-8">
            <button onClick={() => scrollToSection('about')} className="text-stone-300 hover:text-maroon-700 transition-colors duration-200 font-medium">
              About
            </button>
            <button onClick={() => scrollToSection('live-waitlist')} className="text-stone-300 hover:text-maroon-700 transition-colors duration-200 font-medium" data-testid="header-live-link">
              Live Waitlist
            </button>
            <button onClick={() => scrollToSection('services')} className="text-stone-300 hover:text-maroon-700 transition-colors duration-200 font-medium">
              Services
            </button>
            <button onClick={() => scrollToSection('reviews')} className="text-stone-300 hover:text-maroon-700 transition-colors duration-200 font-medium">
              Reviews
            </button>
            <button onClick={() => scrollToSection('hours')} className="text-stone-300 hover:text-maroon-700 transition-colors duration-200 font-medium">
              Hours
            </button>
            <button onClick={() => scrollToSection('contact')} className="text-stone-300 hover:text-maroon-700 transition-colors duration-200 font-medium">
              Contact
            </button>
            <Link to="/waitlist" className="text-stone-300 hover:text-maroon-700 transition-colors duration-200 font-medium" data-testid="view-waitlist-link">
              View Waitlist
            </Link>
            <Button onClick={() => scrollToSection('contact')} className="bg-maroon-800 hover:bg-maroon-900 text-stone-100 transition-colors duration-200">
              Join Waitlist
            </Button>
          </nav>

          {/* Mobile Menu Button */}
          <button
            className="md:hidden text-stone-100 p-2"
            onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
          >
            {mobileMenuOpen ? <X className="h-6 w-6" /> : <Menu className="h-6 w-6" />}
          </button>
        </div>

        {/* Mobile Navigation */}
        {mobileMenuOpen && (
          <nav className="md:hidden pb-4 space-y-2">
            <button onClick={() => scrollToSection('about')} className="block w-full text-left px-4 py-2 text-stone-300 hover:bg-stone-600 hover:text-maroon-700 transition-colors duration-200">
              About
            </button>
            <button onClick={() => scrollToSection('live-waitlist')} className="block w-full text-left px-4 py-2 text-stone-300 hover:bg-stone-600 hover:text-maroon-700 transition-colors duration-200">
              Live Waitlist
            </button>
            <button onClick={() => scrollToSection('services')} className="block w-full text-left px-4 py-2 text-stone-300 hover:bg-stone-600 hover:text-maroon-700 transition-colors duration-200">
              Services
            </button>
            <button onClick={() => scrollToSection('reviews')} className="block w-full text-left px-4 py-2 text-stone-300 hover:bg-stone-600 hover:text-maroon-700 transition-colors duration-200">
              Reviews
            </button>
            <button onClick={() => scrollToSection('hours')} className="block w-full text-left px-4 py-2 text-stone-300 hover:bg-stone-600 hover:text-maroon-700 transition-colors duration-200">
              Hours
            </button>
            <button onClick={() => scrollToSection('contact')} className="block w-full text-left px-4 py-2 text-stone-300 hover:bg-stone-600 hover:text-maroon-700 transition-colors duration-200">
              Contact
            </button>
            <Link to="/waitlist" onClick={() => setMobileMenuOpen(false)} className="block w-full text-left px-4 py-2 text-stone-300 hover:bg-stone-600 hover:text-maroon-700 transition-colors duration-200">
              View Waitlist
            </Link>
            <div className="px-4 pt-2">
              <Button onClick={() => scrollToSection('contact')} className="w-full bg-maroon-800 hover:bg-maroon-900 text-stone-100 transition-colors duration-200">
                Join Waitlist
              </Button>
            </div>
          </nav>
        )}
      </div>
    </header>
  );
};
